import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list"];

  add(event) {
    event.preventDefault();
    const name = this.inputTarget.value.trim().toLowerCase();
    if (!name || this.#alreadyAdded(name)) {
      this.inputTarget.value = "";
      return;
    }
    this.listTarget.append(this.#buildBadge(name));
    this.inputTarget.value = "";
    this.inputTarget.focus();
  }

  remove(event) {
    event.target.closest("[data-category-name]").remove();
  }

  #alreadyAdded(name) {
    return Array.from(this.listTarget.querySelectorAll("[data-category-name]"))
      .some(el => el.dataset.categoryName === name);
  }

  #buildBadge(name) {
    const span = document.createElement("span");
    span.className = "badge bg-primary d-inline-flex align-items-center gap-1";
    span.dataset.categoryName = name;

    span.append(document.createTextNode(name));

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "post[category_names][]";
    input.value = name;
    span.append(input);

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "btn-close btn-close-white p-0";
    btn.style.fontSize = "0.65em";
    btn.setAttribute("data-action", "post-categories#remove");
    span.append(btn);

    return span;
  }
}
